<div class="row">
    <div class="col-12">
        <div class="page-title-box">
            <h4 class="page-title">{{title}}</h4>
            <div>
                <ol class="breadcrumb m-0">
                    <ng-container *ngFor="let item of breadcrumbItems">
                        <li class="breadcrumb-item" *ngIf="!item.active">
                            <a href="javascript: void(0);">{{item.label}}</a>
                        </li>
                        <li class="breadcrumb-item active" *ngIf="item.active">{{item.label}}</li>
                    </ng-container>
                </ol>
            </div>
        </div>
    </div>
</div>